<template>
  <div class="devOps_producerSpaceOther" v-loading="loading">
    <!-- #region 表单搜索部分 -->
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px">
      <el-form-item label="缺陷名称">
        <el-input :style="iptStyle" @change="formSearch('reset')" placeholder="请输入" @keyup.enter.native="formSearch('reset')" v-model="form.title" />
      </el-form-item>
      <el-form-item label="类型">
        <el-tooltip popper-class="popperDom" effect="dark" :content="typetaskStr" placement="top">
          <el-select :style="iptStyle" collapse-tags v-model="form.task_type" multiple filterable @change="formSearch('reset')"
                     placeholder="请选择">
            <el-option v-for="(value, key) in allSelect.BUGTASHOPERATOR" :key="key" :label="key" :value="key" />
          </el-select>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="严重程度">
        <el-tooltip popper-class="popperDom" effect="dark" :content="severityStr" placement="top">
          <el-select :style="iptStyle" collapse-tags v-model="form.severity" multiple filterable @change="formSearch('reset')"
                     placeholder="请选择">
            <el-option v-for="(value, key) in allSelect.BUGTASKPRIORITY" :key="key" :label="value" :value="key" />
          </el-select>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="状态">
        <el-tooltip popper-class="popperDom" effect="dark" :content="statustaskStr" placement="top">
          <el-select :style="iptStyle" multiple filterable collapse-tags @change="formSearch('reset')" v-model="form.status"
                     placeholder="请选择">
            <el-option v-for="(key, value) in allSelect.BUGTASKSTATUS" :key="key" :label="key" :value="value" />
          </el-select>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="计划完成日期" label-width="125px">
        <el-date-picker
            v-model="form.serach_time"
            @change="formSearch('reset')"
            type="daterange"
            value-format="timestamp"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期" />
      </el-form-item>
       <div>
        <el-button  style="letter-spacing: 2px;font-size: 12px;padding: 7px 7px;margin-bottom: 10px;" type="primary"
                    @click="showAddBug()">新增缺陷
        </el-button>
        </div>
    </el-form>
    <!-- #endregion 表单搜索部分 -->

    <!-- #region 表格部分 -->
    <div style="height: 31vh;position: relative;">
      <el-table height="100%"  stripe :header-cell-style="getCellClass" row-key="id" ref="multipleTable"
                :expand-row-keys="expands" @row-click="clickRowHandle" style="margin-top:0;" :cell-style="getRowClass"
                @sort-change="sortChange" :data="tableData">
        <el-table-column fixed="left" prop="db_title" min-width="120" label="缺陷名称" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span  @click="linkFrom( scope.row.db_id)" class="table_text_click_new" v-if="scope.row.db_id">
              [{{ scope.row.db_id }}] {{ scope.row.db_title }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="left" prop="db_status"  align="center" width="100" label="状态" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="taskStatusDisabledFn(scope.row.db_status,scope.row.db_leading,scope.row.db_creator)"
                 @click="linkFrom( scope.row.db_id)"
                 style="text-decoration:underline;color:#409EFF;cursor: pointer;">
              {{allSelect.BUGTASKSTATUS[scope.row.db_status]}}
            </span>
            <span v-else>{{allSelect.BUGTASKSTATUS[scope.row.db_status]}} </span>
          </template>
        </el-table-column>
<!--        <el-table-column prop="project_system" align="center" width="120" label="项目体系">
          <template slot-scope="scope">
            {{ scope.row.project_system && allSelect.TEXTPROJECTSYSTEM &&
          allSelect.TEXTPROJECTSYSTEM[scope.row.project_system] }}
          </template>
        </el-table-column>-->

<!--        <el-table-column  prop="title" min-width="160" label="任务名称">
          <template slot-scope="scope">
            <div @click="showDialogVisible('task', scope.row)" class="table_text_click" v-if="scope.row.db_id">
              [{{ scope.row.db_related_task_id }}] {{ scope.row.d_title }}</div>
          </template>
        </el-table-column>-->
        <el-table-column prop="db_task_type" align="center" width="100" label="类型" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="allSelect.BUGTASHOPERATOR"> {{scope.row.db_task_type}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="db_priority" align="center" width="62" label="优先级" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span class="priority_style" :style="allSelect.COLORPRIORITY[scope.row.db_priority]">
              {{ scope.row.db_priority }}
            </span>
          </template>
        </el-table-column>
        <el-table-column  prop="db_severity" align="center" width="100" label="严重程度" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span class="priority_style" :style="scope.row.db_severity">
              {{ allSelect.BUGTASKPRIORITY[scope.row.db_severity] }}
            </span>
          </template>
        </el-table-column>
<!--        <el-table-column prop="db_module" align="center" width="90" label="系统">
          <template slot-scope="scope">
            <div>{{ allSelect.TEXTMODULES[scope.row.db_module] }}</div>
          </template>
        </el-table-column>-->
<!--        <el-table-column prop="db_creator" align="center" width="80" label="创建人">
          <template slot-scope="scope">
            <div>{{ formatEnToUtf8(allSelect.TEXTUSERS, scope.row.db_creator) }}</div>
          </template>
        </el-table-column>-->
        <el-table-column prop="db_leading" label="负责人" width="90" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ formatEnToUtf8(allSelect.TEXTUSERS, scope.row.db_leading) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="db_plet" sortable="custom" align="center" width="130" label="计划完成日期" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ formatTimeToDate(scope.row.db_plet * 1, "YYYY-MM-DD") }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="act_end_time" sortable="custom" align="center" width="130" label="实际完成时间" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ formatTimeToDate(scope.row.act_end_time * 1, "YYYY-MM-DD HH:mm:ss") }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- #endregion 表格部分 -->

    <!-- #region 分页部分 -->
    <div class="block devOpsSpace_page">
      <span class="demonstration">当前页{{ currentPageLength || 0 }}条</span>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[6,10, 25, 50, 100]"
                     layout="total, prev, pager, next, sizes" :total="count">
      </el-pagination>
    </div>
    <!-- #endregion -->
    <!-- #region dialog 部分 -->
    <create v-if="dialogVisible.create" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.create'
            :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <pending_processing v-if="dialogVisible.pending_processing" :dialogVisible='dialogVisible.pending_processing'
                        :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <to_be_submitted v-if="dialogVisible.to_be_submitted" :dialogVisible='dialogVisible.to_be_submitted'
                     :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <to_be_verified v-if="dialogVisible.to_be_verified" :dialogVisible='dialogVisible.to_be_verified' :hideDialogVisible="hideDialogVisible"
                    :formInfo="checkedInfo" />
    <TaskBug v-if="dialogVisible.task" :dialogVisible='dialogVisible.task' :hideDialogVisible="hideDialogVisible"
             :formInfo="checkedInfo" />
    <!-- #endregion dialog 部分 -->
    <Menu />
  </div>
</template>
<script>
import { TaskBug } from '../../components'
import { create, pending_processing, to_be_submitted, to_be_verified } from '../../components/bug'
import { postDevOpsSpaceAllBugTaskApi, getDevOpsSpaceStageSelectmapApi } from "@/server/tops/devOps";
import { formatEnToUtf8, formatTimeToDate, formatEnToUtf8NoEn } from "@/views/tops/devOps/components/util.js";
import { getStorage, setStorage } from "@/common/utils/storage.js"
import Menu from '@/components/menu/index.vue'
import { mapState, mapMutations } from 'vuex';
export default {
  components: { create, pending_processing, to_be_submitted, to_be_verified, TaskBug,  Menu },
  props: {
    taskid: {
      default: ''
    }
  },
  data() {
    return {
      // 表单搜索条件
      form: {
        status:[],
        task_type:[],
        creator:[],
        leading:[],
        severity:[],
        serach_time:'',
      },
      // 列表
      tableData: [],
      // input 搜索样式
      iptStyle: {
        width: '180px'
      },
      // 弹出层部分
      dialogVisible: {
        create: false,
        pending_processing: false,
        to_be_submitted: false,
        to_be_verified: false,
        task: false,
      },
      // 选中信息
      checkedInfo: {},
      cacheTableData: [],
      count: 10, // 总计
      currentPage: 1, // 当前页
      currentPageLength: 10,
      pageSize: 6, // 每页多少个
      expands: [],
      preciseSwitch: false,
      users: {},
      loading:false,
      tableLoading: false,
      is_admin:false,
      login_username: '',
    };
  },
  async created() {
    let pageSize = getStorage('pageSizeBug', 'localStorage')
    pageSize && (this.pageSize = pageSize * 1);
    await this.$store.dispatch('getDevopsSelect')
    this.users = this.allSelect.TEXTUSERSEN;
  },
  computed: {
    ...mapState(
        {
          // 进度条
          allSelect: (state) => state.devOps.ALLSELECT,
        }
    ),
    /*覅责任*/
    creatorStr() {
      let str = ''
      this.form.creator.forEach(item => {
        str += this.allSelect.TEXTUSERSEN[item] + ' '
      })
      return str;
    },

    /*覅责任*/
    leadingStr() {
      let str = ''
      this.form.leading.forEach(item => {
        str += this.allSelect.TEXTUSERSEN[item] + ' '
      })
      return str;
    },

    /*任务类型*/
    typetaskStr() {
      let str = ''
      this.form.task_type.forEach(item => {
        str += item + ' '
      })
      return str;
    },
    /*严重程度*/
    severityStr() {
      let str = ''
      this.form.severity.forEach(item => {
        str += this.allSelect.BUGTASKPRIORITY[item] + ' '
      })
      return str;
    },
    /*任务状态*/
    statustaskStr() {
      let str = ''
      this.form.status.forEach(item => {
        str += this.allSelect.BUGTASKSTATUS[item] + ' '
      })
      return str;
    },

  },
  watch: {
    'tableData': {
      handler() {
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout()
        })
      },
      deep: true
    }
  },
  async mounted() {
    //const { taskid = '' } = this.$route.query;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.form = { ...this.form, user: username ? [username] : [],task_name: this.taskid};
    this.login_username = username;
    if(this.taskid){
      this.form.user = [];
      this.form.status = [];
      this.form.creator = [];
      this.form.leading = [];

    }
    this.$nextTick(async () => {
      await this.formSearch();
      //this.autoDialogDetailPop(this.tableData)
    })
  },
  methods: {
    ...mapMutations(['filterSelect']),
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 0px 0;height:26px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    // 判断任务状态是否已完成
    taskStatusDisabledFn(state,leading,creator) {
      if(this.login_username === 'joseph_ji'){
        return true;
      }
      if(state === 'completed'){
        return false;
      }
      if(state === 'to_be_submitted' || state === 'pending_processing'){
        if(this.login_username ===leading){
          return true;
        }
      }
      if(state === 'to_be_verified'){
        if(this.login_username === creator){
          return true;
        }
      }
      return false;
    },
    // 扩展行
    clickRowHandle(row, column, event) { },
    // 表单搜索
    async formSearch(type,key) {
      this.form.start_date='';
      this.form.end_date='';
      if(this.form.serach_time){
        if(this.form.serach_time[0]){
          this.form.start_date=this.form.serach_time[0];
        }
        if(this.form.serach_time[1]){
          this.form.end_date=this.form.serach_time[1] + 86400000;

        }
      }
      if(type === 'reset'){
        this.page_num = 1;
        this.currentPage = 1;
      }
      try {
        this.$refs.multipleTable.clearSort()
        let params = {};
        for (const key in this.form) {
          const val = this.form[key];
          params[key] = this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val;
        }
        params.page_num = this.currentPage
        params.page_size = this.pageSize
        this.loading = true;
        const ret = await postDevOpsSpaceAllBugTaskApi(params);
        this.tableData = this.formatTableData(ret.data);
        this.cacheTableData = this.formatTableData(ret.data);
        this.currentPageLength = ret.data.length;
        this.count = ret.count;
        this.is_admin=ret.role.bug_task_admin?ret.role.bug_task_admin:false;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading = false;
      }
    },
    autoDialogDetailPop(tableData){
     // const { taskid = '' } = this.$route.query;
      if (!tableData.length) return;
      if (taskid) { // 弹阶段详情
        if(tableData[0].db_status ==='pending_processing' || tableData[0].db_status === 'to_be_submitted' || tableData[0].db_status === 'to_be_verified'){
          this.showDialogVisible(tableData[0].db_status, tableData[0])
        }else{
          this.showDialogVisible('create', tableData[0])
        }

        return;
      }
      return;
    },

    // 格式化数据
    formatTableData(data) {
      let arr = []
      data.forEach((t, i) => {
        let obj = {
          d_title:t.d_title,
          act_end_time:t.act_end_time,
          db_creator:t.db_creator,
          db_id:t.db_id,
          id:t.db_id,
          db_leading:t.db_leading,
          db_module:t.db_module,
          project_system:t.project_system,
          db_plet:t.db_plet,
          db_plt:t.db_plt,
          db_priority:t.db_priority ,
          db_related_task_id:t.db_related_task_id,
          db_severity:t.db_severity,
          db_status:t.db_status,
          db_task_type:t.db_task_type,
          db_title: t.db_title,
          db_context: t.db_context,
          db_operator_context: t.db_operator_context,
          operator_context:t.db_operator_context,
          taskInfo: {
            id: t.db_related_task_id,
          }
        };
        /*  if (i === 0) {
            obj = { ...obj,  ...this.commonTableDataObj(t) }
          }*/
        arr.push(obj)
      })

      return arr;
    },
    isAdmin() {
      return this.form.is_admin;
    },
    // 公共部分逻辑
    commonTableDataObj(o) {
      const { title, id, user_pm, priority, p_status, p_issue_status, plt, progress, plan_progress, demander, project_system ,reviewed_status} = o;
      return { title, id, user_pm, priority, p_status, p_issue_status, plt, progress, plan_progress, demander, project_system,reviewed_status }
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    // 格式化tableData数据
    formatSortTableData() {
      let arr = []
      this.tableData.forEach(item => {
        if (item.id) {
          const ls = this.tableData.filter(itm => {
            return itm.sortId.startsWith(item.id)
          })
          arr.push(ls)
        }
      })
      return arr;
    },
    // 排序任务时间
    sortTaskTime(key, order) {
      let arr = this.formatSortTableData();
      let newArr = []
      arr.forEach(item => {
        let existDates = [], noExistDates = [];
        let maxDate = 0; // 找出最大日期
        item.forEach(t => {
          const currentDate = t.taskInfo[key];
          if (currentDate && maxDate < currentDate) {
            maxDate = currentDate
          }
          t.taskInfo[key] ? existDates.push(t) : noExistDates.push(t);
        })
        existDates.sort((a, b) => {
          return order === 'descending' ? b.taskInfo[key] - a.taskInfo[key] : a.taskInfo[key] - b.taskInfo[key];
        })
        let tArr = existDates.concat(noExistDates);
        let newTArr = []
        tArr.forEach((t, i) => {
          newTArr.push(i === 0 ? { ...t, maxDate } : t)
        })
        newArr.push(newTArr);
      })
      this.tableData = this.setTableDateHead(newArr, order)
    },
    // 排序需求列表
    setTableDateHead(arr, order) {
      let newArr = [], existDates = [], noExistDates = [];
      arr.forEach(t => {
        t[0].maxDate ? existDates.push(t) : noExistDates.push(t);
      })
      existDates.sort((a, b) => {
        return order === 'descending' ? b[0].maxDate - a[0].maxDate : a[0].maxDate - b[0].maxDate;
      })
      let pArr = existDates.concat(noExistDates);
      pArr.forEach(item => {
        let cacheIdx = 0;
        item.forEach((itm, index) => {
          if (index === 0) {
            const pi = item.filter((it, idx) => {
              if (it.id) {
                cacheIdx = idx;
                return true;
              }
            })
            itm = { ...pi[0], ...itm }
          }
          if (index === cacheIdx && cacheIdx !== 0) {
            itm = { sortId: itm.sortId, taskInfo: itm.taskInfo }
          }
          newArr.push(itm)
        })
      })
      return newArr;
    },
    // 排序事件
    sortChange(column) {
      const { prop, order } = column;
      if(prop === 'db_plet') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? b.db_plet - a.db_plet : a.db_plet - b.db_plet;
        })
      }
      if(prop === 'act_end_time') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? b.act_end_time - a.act_end_time : a.act_end_time - b.act_end_time;
        })
      }
    },
    // 弹出模板
    async showDialogVisible(type, row) {
      if (type === 'releaseing') {
        return;
      }
      //await this.hideDialogVisible('', false)
      this.checkedInfo = row;
      this.dialogVisible[type] = true;
    },
    // 隐藏弹窗
    async hideDialogVisible(nextStep = '', search = true) {
      console.log(11111,this.dialogVisible,55555)
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      if (nextStep && (typeof(nextStep) === 'string')) {
        //const params = nextStep === 'demand' ? { title: this.checkedInfo?.id} : {}
        const params = { title: this.checkedInfo?.db_id};
        const ret = await postDevOpsSpaceAllBugTaskApi(params);
        const tableData = this.formatTableData(ret.data) || [];
        this.checkedInfo = tableData[0];
        this.$nextTick(() => {
          this.checkedInfo && (this.dialogVisible[nextStep] = true);
        })
      } else {
        search && await this.formSearch()
      }
    },
    // 分页
    handleSizeChange(val) {
      this.page_num = 1;
      this.pageSize = val;
      setStorage('pageSizeBug', val, 'localStorage')
      this.formSearch();
    },
    showAddBug(){

      this.$emit('handleClose','addBug');
    },
    linkFrom(db_id){
     // let url = `${window.location.origin}/#/devOpsProducerSpace?tabid=10&db_id=${db_id}`;
      let url = `${window.location.origin}/devops/space/producer?route=devOpsProducerSpace?tabid=10&db_id=${db_id}`;
      window.open(url)
    },
    // 分页事件
    handleCurrentChange(val) {
      this.formSearch();
    },
    // 将英文名字转为中卫
    formatEnToUtf8,
    formatEnToUtf8NoEn,
    // 毫秒值转 YYYY-MM-DD HH:mm:ss
    formatTimeToDate
  },
};
</script>
<style lang="scss">
.devOps_producerSpaceOther {
  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .dialog-footer .el-button {
    font-weight: bold;
    margin-left: 0;
    margin-right: 10px;
  }

  .form_warp .el-form-item {
    margin-bottom: 6px;
  }

  padding-top: 10px;

  // #region select
  .el-select__tags {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
  }

  .el-select__tags::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .el-input__inner {
    margin-left: -5px;
  }

  // #endregion select
  .priority_style {
    border-radius: 5px;
    text-align: center;
    width: fit-content;
    padding: 0 5px;
    margin: auto;
  }

  .el-dialog__header {
    font-weight: bold;
  }

  .el-form-item__label {
    font-weight: bold;
  }

  .devOpsSpace_page {
    // text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;

    .demonstration {
      font-size: 13px;
      color: #606266;
      line-height: 1;
      margin-top: 25px;
      margin-right: 10px;
    }
  }
}

/* #region 滚动条部分 */
.el-table__body-wrapper {
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.el-table__body-wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

.tips-message {
  max-height: 480px;
  overflow-y: auto;
  white-space: pre-wrap;
  background: #f1fbec;
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.websocket_style {
  background-color: #333;
  color: #fefefe;
  padding: 8px;

  a {
    color: #e6a23c;
  }
}

.tips-message::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.tips-message::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.tips-message::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

/* #endregion 滚动条部分 */

.table_options_warp {
  position: absolute;
  z-index: 4;
  left: 20px;
  top: 22px;
  width: 20px;
  cursor: pointer;
}
.devOps_producerSpaceOther .el-form-item__label{
  font-weight: bold;
  font-size: 12px;
}
</style>